export default "__VITE_ASSET__BGWks1i2__"